import table from './table.js'

export default {
    statisticSurveyPeriod: 'Erhebungszeitraum',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    recordingPeriod: 'Erfassungszeitraum',
    recording_start_date: 'Erfassungsstart',
    recording_end_date: 'Erfassungsende',

    createStatisticSurveyPeriod: 'Erhebungszeitraum erstellen',
    createAndEditStatisticSurveyPeriod: 'Erstellen und weiter bearbeiten',

    editStatisticSurveyPeriod: 'Erhebungszeitraum bearbeiten',
    editStatisticSurveyPeriodSuccess: 'Erhebungszeitraum erfolgreich gespeichert',
    editStatisticSurveyPeriodError: 'Erhebungszeitraum konnte nicht gespeichert werden',

    deleteStatisticSurveyPeriod: 'Erhebungszeitraum löschen',
    deleteStatisticSurveyPeriodText: 'Möchtest du diesen Erhebungszeitraum wirklich löschen?',
    deleteStatisticSurveyPeriodSuccess: 'Erhebungszeitraum erfolgreich gelöscht',
    deleteStatisticSurveyPeriodError: 'Erhebungszeitraum konnte nicht gelöscht werden',

    table
}